import React, { useState } from "react";
import axios from "axios";
import { Button } from "semantic-ui-react";
import json2csv from "json2csv";

export default function ContractCsvDownload({ statusText, fetchUrl, reqData }) {
  const [loading, setLoading] = useState(false);

  function onClick() {
    const req = {
      ...reqData,
    };

    setLoading(true);

    axios
      .post(fetchUrl, req)
      .then(({ data }) => {
        makeCsv(data.data, data.name);
      })
      .catch((err) => {
        setLoading(false);
        alert(
          "We could not process your request at this time. Please try again later."
        );
      });
  }

  function makeCsv(rowData, entityName) {
    let baseObj = {};
    let csvPrep = [];
    let headers = [];

    if (rowData.length) {
      headers = Object.keys(rowData[0]);
    } else {
      return setLoading(false);
    }

    Object.keys(headers).forEach((h) => {
      baseObj[headers[h]] = "";
    });

    rowData.forEach((d) => {
      let row = {};

      Object.keys(baseObj).forEach((b) => {
        row[b] = d[b] ? d[b] : "";
      });

      csvPrep.push(row);
    });

    const blob = new Blob([json2csv.parse(csvPrep)], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${
      new Date().toISOString().split("T")[0]
    }-${entityName}-${statusText}-Contracts.csv`;
    link.click();
    setLoading(false);
  }

  if (!fetchUrl) return null;

  return (
    <div>
      <Button
        icon="download"
        labelPosition="right"
        content="Download CSV"
        size="mini"
        basic
        loading={loading}
        onClick={onClick}
      />
    </div>
  );
}

// const headers = [
//   "id",
//   "name",
//   "cost",
//   "status",
//   "last_updated",
//   "customer_first_name",
//   "customer_last_name",
//   "customer_phone",
// ];
